/*
  전역 fetch 유틸 / Global fetch utilities
  ------------------------------------------------------------------
  목적 / Purpose:
  마켓 교차 도메인 리다이렉트나 봇 챌린지가 JSON/섹션 대신 HTML을
  돌려줄 때, .json() · DOMParser().getElementById(...) 가 throw/널 참조로
  깨지는 연쇄를 막는다.
  Guard against redirect / bot-challenge HTML coming back where JSON or
  a section render was expected, which otherwise breaks .json() and the
  DOMParser getElementById(...) cascade.
*/

// JSON 응답을 안전하게 파싱 / Safely parse a JSON response.
// 주의: !res.ok 만으로 중단하지 않는다 — Shopify cart API 는 422 등에서도
// JSON 바디(response.status / errors)를 돌려주고 호출부가 이를 검사한다.
// content-type 으로 application/json 만 통과시키면 안 된다 — 테마는
// Accept: application/javascript 로 요청하고, /cart/add 등 Shopify cart
// 엔드포인트는 본문은 JSON 이지만 content-type 을 application/javascript
// (또는 text/javascript)로 돌려준다. 그래서 'application/json' 만 허용하면
// 정상 응답까지 null 이 되어 장바구니/드로어 갱신이 통째로 막혔다.
// 대신 명백한 HTML(마켓 리다이렉트/봇 챌린지)만 걸러내고, 그 외에는
// 실제로 JSON 파싱을 시도해 성공하면 통과시킨다.
// Note: do NOT gate on an exact application/json content-type — the theme
// requests with Accept: application/javascript, and Shopify cart endpoints
// (/cart/add etc.) return a JSON *body* but an application/javascript
// (or text/javascript) content-type. Allowing only 'application/json' turned
// successful responses into null and silently broke every cart/drawer update.
// Instead bail only on clearly-HTML responses (market redirect / bot challenge),
// and otherwise actually attempt to parse JSON, passing it through on success.
window.fetchJsonSafe = async function (url, options) {
  const res = await fetch(url, options);

  const contentType = res.headers.get('content-type') || '';
  if (contentType.includes('text/html')) return null; // HTML(리다이렉트/봇 챌린지)면 중단 / bail on HTML

  try {
    return await res.json();
  } catch (e) {
    return null; // JSON 이 아니거나 깨졌으면 중단 / bail when body isn't valid JSON
  }
};

// 섹션 렌더링(HTML) 응답을 안전하게 파싱 / Safely fetch a Section Rendering (HTML) response.
// ?section_id= / ?view= 처럼 HTML 을 돌려주는 엔드포인트용.
// 비정상 응답이면 null 을 반환해 호출부가 조용히 빠져나가게 한다.
// For endpoints that return HTML; returns null on a non-OK response so the
// caller can bail silently instead of parsing a redirect page.
window.fetchTextSafe = async function (url, options) {
  const res = await fetch(url, options);
  if (!res.ok) return null; // 비정상 응답이면 중단 / bail on non-OK
  return res.text();
};
